export default __webpack_public_path__ + "static/media/information--hurricane-evacuation-route--g1.51f3af3c.png";